import React from 'react';
import ReactDOM from 'react-dom';

import AppWrapper from './app-wapper';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    //<React.StrictMode>
        <AppWrapper/>
    //</React.StrictMode>
    ,
    document.getElementById('root')
);
serviceWorker.unregister();
